import { render, staticRenderFns } from "./text_dialog.vue?vue&type=template&id=3042442d&scoped=true"
import script from "./text_dialog.vue?vue&type=script&lang=js"
export * from "./text_dialog.vue?vue&type=script&lang=js"
import style0 from "./text_dialog.vue?vue&type=style&index=0&id=3042442d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042442d",
  null
  
)

export default component.exports